(function () {
    'use strict';

    angular
        .module('app')
        .service('policyholdersService', service);

    service.$inject = ['$http', 'urlHelper'];

    /** @ngInject */
    function service($http, urlHelper) {

        this.AddressType = {
            BillingAndCorrespondence: 'Billing and Correspondence',
            Billing: 'Billing',
            Correspondence: 'Correspondence'
        }

        this.addMembershipId = function (policyholderLink, membershipId) {
            var request = {
                "policyholderLink": policyholderLink,
                "membershipId": membershipId
            }

            return $http.post(urlHelper.getSuperbrandApiUrl() + 'policyholders/onlinelinks', request);
        }

        this.addMembershipIdByPolicyholderId = function (policyholderId, membershipId) {
            var request = {
                "membershipId": membershipId
            }

            return $http.post(urlHelper.getSuperbrandApiUrl() + 'policyholders/' + policyholderId + '/membership',
                request);
        }
        
        this.getByPolicy = function(policyNumber, policyHash) {
            var url = urlHelper.getSuperbrandApiUrl() +
                'policyholders/by-policy?policyNumber=' + encodeURIComponent(policyNumber) +
                '&policyHash=' + encodeURIComponent(policyHash);

            return $http.get(url).then(function(response) {
                return response.data;
            });
        }

        this.getAddressByType = function(policyholderAddresses, addressType) {
            var items = policyholderAddresses.filter(function(address) {
                return address.addressType === addressType;
            });

            if (items.length)
                return items[0];

            return null;
        }

        this.getPreferableAddress = function (policyholderAddresses) {
            var addressTypes = [
                this.AddressType.BillingAndCorrespondence,
                this.AddressType.Billing,
                this.AddressType.Correspondence
            ];

            for (var i = 0; i < addressTypes.length; ++i) {
                var address = this.getAddressByType(policyholderAddresses, addressTypes[i]);
                if (address)
                    return address;
            }

            return null;
        };

        this.getByMembershipId = function (membershipId) {
            var url = urlHelper.getSuperbrandApiUrl() +
                'policyholders?membershipId=' +
                encodeURIComponent(membershipId);

            return $http.get(url).then(function (response) {
                
                return response.data;
            });
        }

        this.getPolicyholderAttachments = function (policyholderId) {
            var url = urlHelper.getSuperbrandApiUrl() +
                'policyholders/' + encodeURIComponent(policyholderId) +
                '/attachments';

            return $http.get(url).then(function (response) {
                return response.data;
            });
        }
    }
}());
